import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
const API_URL = `${API_BASE_URL}/uploads`;
const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch news from API
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/blogs/type/news`)
      .then((res) => res.json())
      .then((data) => {
        // ✅ Ensure data is always an array
        if (Array.isArray(data)) {
          setNewsList(data);
        } else if (Array.isArray(data.data)) {
          setNewsList(data.data);
        } else {
          setNewsList([]); // fallback empty array
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setNewsList([]);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-6 py-12 max-w-7xl mt60">
        <p className="text-center text-lg">Loading news...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="container mx-auto px-6 py-12 max-w-7xl mt60">
        {/* Category and Section Title */}
        <div className="mb-12">
          <p className="text-[18px] mb-2 text-gray-700 font-ui">Category</p>
          <h1 className="text-5xl md:text-6xl font-heading text-[#FBBF24]">
            News
          </h1>
        </div>

        {/* News Grid */}
        {newsList.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {newsList.map((blog) => (
              <div
                key={blog._id}
                className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col transition-all duration-300 hover:scale-105 hover:shadow-lg"
                style={{ height: "100%" }}
              >
                {/* Image */}
                <img
                  src={`${API_URL}/${blog.image}`}
                  alt={blog.title}
                  className="w-full h-48 object-cover"
                />

                {/* Card Body */}
                <div className="p-6 flex flex-col justify-between flex-grow">
                  <div>
                    {/* Date & Author */}
                    <div className="flex items-center text-gray-700 font-ui text-sm mb-4 space-x-2">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z"
                        />
                      </svg>
                      <span>
                        {blog.publishDate
                          ? new Date(blog.publishDate).toLocaleDateString()
                          : "No date"}
                      </span>
                      <span className="ml-2 font-semibold">
                        by {blog.author || "Unknown"}
                      </span>
                    </div>

                    {/* Title */}
                    <h3 className="font-heading mb-2 text-[22px] font-bold text-[#111827]">
                      {blog.title}
                    </h3>

                    {/* Overview */}
                    <p className="text-[15px] mb-4 text-[#374151] font-ui line-clamp-3">
                      {blog.overview}
                    </p>
                  </div>

                  {/* Read More Button */}
                  <Link
                    to={`/news/${blog._id}`}
                    className="text-[#5B42F3] font-ui font-semibold flex items-center gap-1 hover:underline mt-auto"
                  >
                    Read More
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
         <div className="col-span-full text-center py-20 bg-white rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-700 mb-4">
               No News Available
              </h3>
              <p className="text-gray-500">
             We're working on bringing you the latest updates and insights. Stay tuned!
              </p>
            </div>
        )}
      </div>

      {/* Bottom Call to Action */}
      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-4 text-[30px]">
            Enjoyed the blog? Let's build something great together.
          </h2>
          <p className="text-[18px] font-ui mb-8">
            Ready to transform your institution with cutting-edge ERP solutions?
          </p>
          <Link to="/freedemo" className="inline-block">
            <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2">
              Book Free Demo
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </Link>
        </div>
      </section>
    </div>

  );
};

export default News;
